// 获取首页任务信息
export function getTaskInfo () {
  return $api.get('/s1/apptask.list')
}
// 进行中的任务-任务轮询
export function runingTask (params) {
  return $api.get('/s1/apptask.start', { params: params })
}
// 任务详情
export function taskDetail (params) {
  return $api.get('/s1/apptask.detail', { params: params })
}
// 放弃任务
export function giveUpTask (params) {
  return $api.get('/s1/apptask.giveup', { params: params })
}
// 领取红包
export function checkStatusTask (params) {
  return $api.get('/s1/apptask.check_status', { params: params })
}

// 用户证书
export function start () {
  return $api.get(`/s1/bbee${window.location.search}`)
}
